var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.14138V10.9183M11 14.6952H11.0097M9.65086 2.31801L1.63708 15.7323C1.19258 16.4763 0.970333 16.8484 1.00318 17.1537C1.03183 17.42 1.17581 17.662 1.39928 17.8195C1.65549 18 2.09907 18 2.98622 18H19.0138C19.9009 18 20.3445 18 20.6007 17.8195C20.8242 17.662 20.9682 17.42 20.9968 17.1537C21.0297 16.8484 20.8074 16.4763 20.3629 15.7323L12.3491 2.31801C11.9062 1.57663 11.6848 1.20595 11.3959 1.08145C11.1439 0.97285 10.8561 0.97285 10.6041 1.08145C10.3152 1.20595 10.0938 1.57664 9.65086 2.31801Z",
    stroke: "#FF9900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWarning);
export default __webpack_public_path__ + "static/media/LogoutWarning.e9f43e1e0cb5865ed805b660cedafcb2.svg";
export { ForwardRef as ReactComponent };